

export enum AppEvents {
  // EVENTOS DE CITAS
  appointment_started = 'appointment_started',        // Inicio de cita
  appointment_products_chosen = 'appointment_products_chosen', // Selección de productos exitosa
  appointment_timeslot_chosen = 'appointment_timeslot_chosen', // Selección de horario exitosa
  appointment_completed = 'appointment_completed',       // Cita completada
  appointment_confirmed = 'appointment_confirmed',       // Cita confirmada
  appointment_canceled = 'appointment_canceled',        // Cita cancelada
  // EVENTOS DE CLÍNICAS FAVORITAS
  preferred_clinic_mark = 'preferred_clinic_mark',     // Clínica favorita agregada
  preferred_clinic_unmark = 'preferred_clinic_unmark',   // Clínica favorita eliminada
  preferred_clinic_reordered = 'preferred_clinic_reordered',    // Clínica favorita ordenada
  // EVENTOS DE VALIDACIÓN DE CÓDIGO DE INICIO DE SESIÓN
  validation_code_requested = 'validation_code_requested', // Código de validación solicitado
  validation_code_sent = 'validation_code_sent',      // Código de validación enviado
  validation_code_success = 'validation_code_success',    // Código de validación exitoso
  // EVENTOS DE INICIO DE SESIÓN INICIADOS Y EXITOSOS
  login_started = 'login_started',        // Inicio de sesión iniciado
  login_success = 'login_success',       // Inicio de sesión exitoso
  // EVENTOS DE NAVEGACION EN PANTALLAS
  screen_view = 'screen_view',
  // EVENTOS DE BOTONES ESTRATEGICOS
  button_click = 'button_click',
  app_version_block_shown = 'app_version_block_shown',
  app_version_update_tapped = 'app_version_update_tapped',
  // EVENTOS DE FLUJO DE E-COMMERCE
  product_item_list = 'product_item_list',    // Lista de productos vista
  product_item_view = 'product_item_view',    // Producto visto
  product_add_to_cart = 'product_add_to_cart',          // Producto agregado al carrito
  product_update_in_cart = 'product_update_in_cart',     // Producto actualizado en el carrito
  product_remove_from_cart = 'product_remove_from_cart',     // Producto eliminado del carrito
  product_checkout_started = 'product_checkout_started',    // Inicio de checkout
  product_payment_method_selected = 'product_payment_method_selected', // Método de pago seleccionado
  product_billing_info_added = 'product_billing_info_added', // Información de facturación agregada
  product_payment_info_added = 'product_payment_info_added', // Información de pago agregada
  product_purchase_completed = 'product_purchase_completed',  // Compra completada
}

export enum ButtonNames {
  book_appointment_dashboard = 'book_appointment_dashboard',
  preferred_clinics_dashboard = 'preferred_clinics_dashboard',
  my_appointments_dashboard = 'my_appointments_dashboard',
  logout_dashboard = 'logout_dashboard',
}